import { CircularProgress, Button as MuiButton, useTheme } from '@material-ui/core'
import classNames from 'classnames'
import React, { forwardRef } from 'react'

import { ButtonProps } from './ButtonProps'
import { useButtonStyles } from './ButtonStyles'

interface ButtonType {
  <C extends React.ElementType = 'button'>(props: ButtonProps<C> & { component?: C }): React.ReactElement
  displayName?: string
}

// eslint-disable-next-line react/display-name -- false positive
export const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { textTransform, loading, classes: classesOverride, className, ...muiProps } = props
  const { classes: remove, ...styleProps } = props
  const classes = useButtonStyles(styleProps)
  const { typography } = useTheme()
  const loadingIndicator = {
    startIcon: <CircularProgress color="inherit" size={typography.button.fontSize} />,
    disabled: true,
  }
  return (
    <MuiButton
      ref={ref}
      classes={{ ...classes, ...classesOverride }}
      className={classNames([className, 'pm-button'])}
      {...muiProps}
      {...(loading && loadingIndicator)}
    />
  )
}) as ButtonType

Button.displayName = 'Button'
